import { getRandomPropping } from '../common';

function pickPropping({ item }) {
  return getRandomPropping(item);
}

export default { pickPropping };
